import {Injectable, EventEmitter} from "@angular/core";
import {HttpErrorInterface} from "../intefraces/http-error.interface";


export class HttpErrorService {

    private _handler: EventEmitter<HttpErrorInterface>;

    constructor() {
        this._handler = new EventEmitter<HttpErrorInterface>();
    }

    get handler(): EventEmitter<HttpErrorInterface> {
        return this._handler;
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
